// extracted by mini-css-extract-plugin
export var markdown = "_sk-0";
export var tableWrapper = "_sk-1";